import {
	Box,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	IconButton,
	InputAdornment,
	Link,
	MenuItem,
	TextField,
	Toolbar,
	Tooltip,
	Typography,
	CircularProgress
} from '@material-ui/core'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import {
	AddOutlined,
	ArrowBackIosOutlined,
	ArrowForwardIosOutlined,
	CalendarToday,
	Clear,
	Close,
	Search
} from '@material-ui/icons'
import { KeyboardDatePicker } from '@material-ui/pickers'
import clsx from 'clsx'
import { useFormik } from 'formik'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { Fragment } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link as RouterLink } from 'react-router-dom'
import * as yup from 'yup'

import { showError, showSuccess } from '../../../../actions/misc/misc.actions'
import { updateFacilityPlaygroups } from '../../../../actions/playgroups/playgroups.actions'
import { getSpecificAreas, PLAYGROUP_STATUSES } from '../../../../utils'
import { MainButton } from '../../../Button/MainButton'
import DeleteConfirmation from '../../../Dialogs/DeleteConfirmation'
import { FilterButton } from '../../Components/Playgroups/FilterButton'

const useStyles = makeStyles((theme) => ({
	headerButton: {
		fontFamily: 'Nunito',
		fontWeight: '700',
		'& .MuiButton-label': {
			lineHeight: '19px',
			fontSize: '14px'
		}
	},
	addClientButton: {
		color: theme.palette.secondary.main,
		borderColor: theme.palette.secondary.main,
		padding: '7px 40px 8px 24px',
		'& .MuiButton-label': {
			'& .MuiButton-startIcon': {
				marginRight: 16
			}
		}
	},
	toolbarWrapper: {
		display: 'flex',
		flexDirection: 'column',
		backgroundColor: '#F9F9F9'
	},
	petStatusIcon: {
		position: 'absolute',
		left: 0
	},
	toolbarItemsWrapper: {
		display: 'flex',
		alignItems: 'center',
		flexWrap: 'wrap',
		'& > *': {
			marginRight: '16px',
			marginBottom: 8
		}
	},
	toolbar: {
		display: 'flex',
		alignItems: 'center',
		flexWrap: 'wrap'
	},
	searchField: {
		minWidth: 150
	},
	datePickerContainer: {
		display: 'flex',
		alignItems: 'center',
		position: 'relative'
	},
	datePicker: {
		color: '#FFFFFF',
		opacity: 0,
		position: 'absolute',
		top: 0,
		height: 38,
		margin: 0,
		'& *': {
			height: 0,
			padding: 0,
			margin: 0
		}
	},
	calendarButton: {
		'& svg': {
			fill: theme.palette.primary.main
		}
	},
	calendarHeaderButtons: {
		fill: theme.palette.primary.main
	},
	filterButton: {
		zIndex: 1
	},
	calendarDateButton: {
		zIndex: 1,
		border: '1px solid #D0CFD2',
		padding: '7px 16px 8px 24px',
		color: '#4D4C4F',
		fontWeight: '700',
		'& .MuiButton-label': {
			'& .MuiButton-endIcon': {
				marginLeft: 16
			},
			whiteSpace: 'nowrap'
		}
	},
	dateChangeButton: {
		border: '1px solid #D0CFD2',
		height: 38,
		width: 38,
		padding: 5,
		'& svg': {
			height: 16
		}
	},
	addAppointmentButton: {
		color: theme.palette.secondary.main,
		borderColor: theme.palette.secondary.main,
		padding: '7px 40px 8px 24px',
		'& .MuiButton-label': {
			'& .MuiButton-startIcon': {
				marginRight: 16
			}
		}
	},
	autoAssignButton: {
		color: theme.palette.secondary.main,
		borderColor: theme.palette.secondary.main,
		position: 'absolute',
		right: 0
		// padding: '7px 40px 8px 24px',
		// '& .MuiButton-label': {
		// 	'& .MuiButton-startIcon': {
		// 		marginRight: 16
		// 	}
		// }
	},
	scheduleAggregatesWrapper: {
		display: 'flex',
		flexWrap: 'wrap',
		paddingTop: '10px',
		paddingBottom: '12px'
	},
	scheduleAggregate: {
		display: 'flex',
		flex: '238px 0 0',
		flexWrap: 'wrap',
		justifyContent: 'space-between',
		padding: '10px 16px',
		borderRadius: 6,
		color: '#4D4C4F',
		marginRight: 8,
		marginBottom: 8,
		background: '#F3F3F3'
	},
	membershipWrapper: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center'
	},
	membershipIcon: {
		color: '#6B4AD6',
		'&::before': {
			fontSize: '14px',
			lineHeight: '14px'
		}
	},
	membershipType: {
		fontFamily: 'Nunito',
		fontSize: '14px',
		fontWeight: 600,
		lineHeight: '19px',
		color: '#777679',
		textTransform: 'capitalize'
	},
	filterIcon: {
		fontSize: 19,
		color: '#777679',
		marginRight: 8
	},
	filterButtonLabel: {
		alignItems: 'center'
	},
	noWrap: {
		whiteSpace: 'nowrap'
	},
	dialogTitle: {
		justifyContent: 'space-between',
		alignItems: 'center',
		'& .MuiTypography-root': {
			width: '100%'
		},
		padding: '16px 24px 0px'
	},
	// form: {
	// 	width: '100%',
	// 	display: 'flex',
	// 	flexWrap: 'wrap',
	// 	justifyContent: 'space-between',
	// 	'& .MuiTextField-root, .MuiAutocomplete-root, .MuiFilledInput-root': {
	// 		// width: 270,
	// 		minWidth: 270
	// 		// minHeight: 40
	// 	}
	// },
	form: {
		display: 'flex',
		flexWrap: 'wrap',
		margin: '24px 0px',
		'& .MuiTextField-root': {
			minWidth: '274px !important'
		},
		'& .MuiFilledInput-underline': {
			minWidth: '274px !important'
		}
	},
	row: {
		// display: 'flex',
		// width: '100%',
		// justifyContent: 'space-between',
		// marginBottom: 20,
		// height: 56,

		display: 'flex',
		width: '100%',
		flexDirection: 'row',
		justifyContent: 'space-between'
	},
	input: {
		width: '48%',
		marginBottom: 16,
		// minWidth: 419,
		'& input': {
			minHeight: 32,
			padding: '23px 12px 10px', // this avoids label overlapping
			backgroundColor: '#FFF',
			'&:hover': {
				//you want this to be the same as the backgroundColor above
				backgroundColor: '#FFF'
			}
		}
	},
	select: {
		width: '48%',
		marginBottom: 16,
		// minWidth: 419,
		'& [class*=MuiSelect-root]': {
			minHeight: 45,
			display: 'flex',
			alignItems: 'flex-end',
			backgroundColor: '#FFF',
			'&:hover': {
				//you want this to be the same as the backgroundColor above
				backgroundColor: '#FFF'
			}
		}
	},
	autocomplete: {
		// minWidth: 419
		width: '48%',
		marginBottom: 16,
		'& input': {
			minHeight: 36,
			// padding: '23px 12px 10px', // this avoids label overlapping
			backgroundColor: '#FFF',
			'&:hover': {
				//you want this to be the same as the backgroundColor above
				backgroundColor: '#FFF'
			}
		},
		'& [class*=MuiInputBase-root]': {
			backgroundColor: '#FFF',
			'&:hover': {
				//you want this to be the same as the backgroundColor above
				backgroundColor: '#FFF'
			}
		}
	},
	dialogActions: {
		justifyContent: 'flex-start',
		width: '100%',
		padding: '24px 0px'
	}
}))

const STATUSES = Object.entries(PLAYGROUP_STATUSES).map(([id, label]) => ({ id, label }))

const validationSchema = yup.object({
	name: yup.string().required(),
	playgroup_type_id: yup.string().required(),
	capacity: yup.string().required().min(0).max(99),
	kennel_block_id: yup.string(),
	default_status: yup
		.string()
		.required()
		.oneOf(STATUSES.map((t) => t.id))
})

export const PlaygroupsToolbar = React.forwardRef((props, ref) => {
	const classes = useStyles()
	const theme = useTheme()
	const dispatch = useDispatch()

	const [search, setSearch] = useState('')
	const [isOpen, setIsOpen] = useState(false)
	const [isAddNewPlaygroupOpen, setIsAddNewPlaygroupOpen] = useState(false)
	const [playgroupToEdit, setPlaygroupToEdit] = useState(null)
	const [isDeleteOpen, setIsDeleteOpen] = useState(false)
	const [isDeleteLoading, setIsDeleteLoading] = useState(false)

	const selectedFacility = useSelector((state) => state.specific.facilities.selected)
	const loading = useSelector((state) => state.specific.visits.loading)

	let {
		tableRef,
		date,
		setDate,
		changeDate,
		onSearchChange,
		title = 'Playgroups',
		darkTitle = false,
		allowDateChange = true,
		allowFilter = false,
		containerStyles = null,
		allowAdd = false,
		canAssign = false
	} = props

	// const canAssign = true

	const { playgroup_types: playgroupTypes = [], kennel_blocks: kennelBlocks = [], areas = [], playgroups = [] } =
		selectedFacility || {}
	const { indoor: indoorAreas, outdoor: outdoorAreas } = getSpecificAreas(selectedFacility)

	useEffect(() => {
		setPlaygroupToEdit(null)
	}, [])

	useEffect(() => {
		if (props.playgroupToEdit && props.playgroupToEdit._id) {
			setPlaygroupToEdit(props.playgroupToEdit)
			formik.setValues({ ...props.playgroupToEdit }, true).then(() => {
				// formik.validateForm()
				setIsAddNewPlaygroupOpen(true)
			})
		}
	}, [props.playgroupToEdit])

	useEffect(() => {
		if (onSearchChange) onSearchChange(search)
		else if (tableRef) onSearchChangeInternal(search)
	}, [search])

	const onSearchChangeInternal = (searchText) => {
		tableRef.current.dataManager.changeSearchText(searchText)
		tableRef.current.onSearchChangeDebounce(searchText)
	}

	const updateDate = (date) => {
		setDate(moment(date).format('YYYY-MM-DD'))
		setIsOpen(false)
	}

	const formik = useFormik({
		initialValues: {
			name: '',
			playgroup_type_id: '',
			capacity: '',
			kennel_block_id: '',
			default_indoor_play_area_id: '',
			default_outdoor_play_area_id: '',
			default_status: '',
			status: ''
		},
		validationSchema,
		validateOnMount: true,
		onSubmit: async (values) => {
			try {
				const playgroups = selectedFacility.playgroups || []
				const editing = playgroupToEdit && playgroupToEdit._id

				if (editing) {
					const index = playgroups.findIndex((e) => e._id === playgroupToEdit._id)
					if (index >= 0) {
						// editting
						playgroups[index] = { ...playgroups[index], ...values }
					}
				} else {
					// creating
					playgroups.push({
						...values,
						status: values.default_status,
						area_id: values.default_status === 'in use' ? values.default_indoor_play_area_id : '',
						new: true
					})
				}
				const updatedFacility = await updateFacilityPlaygroups(selectedFacility._id, playgroups)
				dispatch({ type: 'UPDATE_FACILITY_SUCCESS', payload: updatedFacility })
				dispatch(showSuccess(editing ? 'Playgroup updated' : 'Playgroup created'))
				setIsAddNewPlaygroupOpen(false)
			} catch (error) {
				dispatch(showError(error))
			}
		}
	})

	const update = (key, val) => {
		formik.setFieldValue(key, val)
	}

	const onCloseDialog = () => {
		if (!formik.isSubmitting) {
			formik.resetForm()
			setIsAddNewPlaygroupOpen(false)
		}
	}

	const onConfirmDelete = async () => {
		try {
			setIsDeleteLoading(true)
			const editing = playgroupToEdit && playgroupToEdit._id

			if (!editing) return

			const playgroups = selectedFacility.playgroups.map((g) => {
				return {
					...g,
					delete: g._id === playgroupToEdit._id ? true : false
				}
			})

			const updatedFacility = await updateFacilityPlaygroups(selectedFacility._id, playgroups)
			dispatch({ type: 'UPDATE_FACILITY_SUCCESS', payload: updatedFacility })
			dispatch(showSuccess('Playgroup deleted'))
			setIsAddNewPlaygroupOpen(false)
		} catch (error) {
			dispatch(showError(error))
		} finally {
			setIsDeleteLoading(false)
			setIsDeleteOpen(false)
		}
	}

	return (
		<div ref={ref} className={classes.toolbarWrapper}>
			<Toolbar
				className={[
					classes.toolbar,
					containerStyles ? containerStyles : { padding: '19px 25px 6px 25px !important' }
				]}>
				<div className={classes.toolbarItemsWrapper}>
					{!darkTitle ? (
						<Typography
							variant="h6"
							color="primary"
							style={{
								fontSize: '22px',
								fontWeight: 800,
								lineHeight: '30px',
								whiteSpace: 'nowrap',
								overflow: 'hidden',
								textOverflow: 'ellipsis'
							}}>
							{title}
						</Typography>
					) : (
						<Typography variant="h5" style={{ fontWeight: 800 }}>
							{title}
						</Typography>
					)}
					<TextField
						value={search}
						className={classes.searchField}
						onChange={(event) => setSearch(event.target.value)}
						placeholder="Search"
						variant="filled"
						InputProps={{
							startAdornment: (
								<InputAdornment position="start">
									<Tooltip title="Search">
										<Search fontSize="small" />
									</Tooltip>
								</InputAdornment>
							),
							endAdornment: (
								<InputAdornment position="end">
									<IconButton
										disabled={!search}
										onClick={() => setSearch('')}
										aria-label="Clear">
										<Clear fontSize="small" aria-label="clear" />
									</IconButton>
								</InputAdornment>
							),
							inputProps: {
								'aria-label': 'Search'
							}
						}}
					/>
					{allowFilter && <FilterButton />}
					{allowDateChange && (
						<div className={classes.datePickerContainer}>
							<Button
								className={clsx(classes.headerButton, classes.calendarDateButton)}
								onClick={() => setIsOpen(true)}
								variant="outlined"
								endIcon={<CalendarToday style={{ height: 19, width: 19, fill: '#777679' }} />}
								classes={{
									label: classes.noWrap
								}}
								size="large">
								{moment(date).format('MMM D, YYYY')}
							</Button>
							<KeyboardDatePicker
								disableToolbar
								open={isOpen}
								onOpen={() => setIsOpen(true)}
								onClose={() => setIsOpen(false)}
								variant="inline"
								format="MM/DD/YYYY"
								margin="normal"
								id="start-date"
								label="Start Date"
								inputVariant="filled"
								value={date}
								onChange={updateDate}
								className={classes.datePicker}
								rightArrowIcon={
									<ArrowForwardIosOutlined className={classes.calendarHeaderButtons} />
								}
								leftArrowIcon={<ArrowBackIosOutlined className={classes.calendarHeaderButtons} />}
								KeyboardButtonProps={{
									'aria-label': 'Start Date',
									className: classes.calendarButton
								}}
							/>
						</div>
					)}
					{allowDateChange && (
						<div style={{ display: 'flex' }}>
							<IconButton
								className={classes.dateChangeButton}
								onClick={() => changeDate('subtract')}
								style={{ marginRight: 8 }}>
								<ArrowBackIosOutlined style={{ fill: '#777679' }} />
							</IconButton>
							<IconButton className={classes.dateChangeButton} onClick={() => changeDate('add')}>
								<ArrowForwardIosOutlined style={{ fill: '#777679' }} />
							</IconButton>
						</div>
					)}
					{allowAdd && (
						<Button
							variant="outlined"
							className={clsx(classes.headerButton, classes.addAppointmentButton)}
							startIcon={<AddOutlined style={{ fill: theme.palette.secondary.main }} />}
							size="large"
							onClick={() => {
								formik.resetForm()
								formik.validateForm()
								setPlaygroupToEdit(null)
								setIsAddNewPlaygroupOpen(!isAddNewPlaygroupOpen)
							}}>
							New playgroup
						</Button>
					)}

					{loading ? <CircularProgress size="2rem" /> : null}
				</div>
				<Button variant='outlined'
					disabled={!canAssign}
					onClick={props.autoAssign} style={{
						color: '#6B4AD6',
						position: 'absolute',
						right: 16,
						marginBottom: 8,
						opacity: canAssign ? 1 : 0.5
					}}>AUTO-ASSIGN PLAYGROUPS</Button>
			</Toolbar>
			<Dialog
				open={isAddNewPlaygroupOpen}
				onClose={onCloseDialog}
				PaperProps={{
					style: {
						// width: 920,
						maxWidth: 920
						// minHeight: 374,
						// maxHeight: 500,
						// overflowY: 'scroll'
					}
				}}>
				<DialogTitle style={{ fontSize: 16 }} className={classes.dialogTitle}>
					<Box display="flex" alignItems="center">
						<Box flexGrow={1}>{playgroupToEdit ? 'Edit Playgroup' : 'Add New Playgroup'}</Box>
						<Box>
							<IconButton onClick={onCloseDialog}>
								<Close color="inherit" fontSize="small" />
							</IconButton>
						</Box>
					</Box>
				</DialogTitle>
				<DialogContent>
					<form className={classes.form} onSubmit={formik.handleSubmit}>
						<Box className={classes.row}>
							<TextField
								className={classes.input}
								value={formik.values.name}
								variant="filled"
								label="Name"
								required
								onChange={(e, v) => {
									e.preventDefault()
									update('name', e.target.value)
								}}
								helperText={`${formik.values.name?.length || 0} / 20 Max Characters`}
								inputProps={{ maxLength: 20 }}
							/>
							<TextField
								select
								label="Playgroup Type"
								required
								className={classes.select}
								value={formik.values.playgroup_type_id}
								onChange={(e) => update('playgroup_type_id', e.target.value)}
								variant="filled">
								{playgroupTypes.map(({ _id, name }, i) => (
									<MenuItem key={'playgroupTypes-' + i} value={_id}>
										{name}
									</MenuItem>
								))}
							</TextField>
						</Box>
						<Box className={classes.row}>
							<TextField
								className={classes.input}
								value={formik.values.capacity}
								variant="filled"
								type="number"
								required
								label="Capacity (Numerical value required)"
								onChange={(e, v) => {
									if (e.target.value >= 0 && e.target.value <= 99)
										update('capacity', e.target.value)
								}}
								InputProps={{
									inputProps: {
										max: 99,
										min: 1
									}
								}}
							/>
							<TextField
								select
								label="Default Kennel Block"
								className={classes.select}
								value={formik.values.kennel_block_id}
								onChange={(e) => update('kennel_block_id', e.target.value)}
								variant="filled">
								{kennelBlocks.map(({ _id, name }, i) => (
									<MenuItem key={'kennelBlocks-' + i} value={_id}>
										{name}
									</MenuItem>
								))}
								<MenuItem key={'kennelBlocks-none'} value="">
									None
								</MenuItem>
							</TextField>
						</Box>

						<Box className={classes.row}>
							<TextField
								select
								label="Default Indoor Play Area"
								className={classes.select}
								value={formik.values.default_indoor_play_area_id}
								onChange={(e) => update('default_indoor_play_area_id', e.target.value)}
								variant="filled">
								{indoorAreas.map(({ _id, name }, i) => (
									<MenuItem key={'indoorAreas-' + i} value={_id}>
										{name}
									</MenuItem>
								))}
							</TextField>
							<TextField
								select
								label="Default Outdoor Play Area"
								className={classes.select}
								value={formik.values.default_outdoor_play_area_id}
								onChange={(e) => update('default_outdoor_play_area_id', e.target.value)}
								variant="filled">
								{outdoorAreas.map(({ _id, name }, i) => (
									<MenuItem key={'outdoorAreas-' + i} value={_id}>
										{name}
									</MenuItem>
								))}
							</TextField>
						</Box>

						<Box className={classes.row}>
							<TextField
								select
								label="Default Status"
								required
								className={classes.select}
								value={formik.values.default_status}
								onChange={(e) => {
									update('default_status', e.target.value)
									update('status', e.target.value)
								}}
								variant="filled">
								{STATUSES.map(({ id, label }, i) => (
									<MenuItem key={'STATUSES-' + i} value={id}>
										{label}
									</MenuItem>
								))}
							</TextField>
						</Box>

						<DialogActions className={classes.dialogActions}>
							<MainButton
								variant="contained"
								label="Save"
								onClick={() => formik.submitForm()}
								disabled={!formik.isValid || formik.isSubmitting}
							/>
							<MainButton
								variant="outlined"
								label="Cancel"
								onClick={onCloseDialog}
								disabled={formik.isSubmitting}
							/>
							{playgroupToEdit && playgroupToEdit._id && (
								<Link
									component={RouterLink}
									style={{
										fontFamily: 'Nunito',
										color: '#D02C2C',
										fontSize: '14px',
										lineHeight: '19px',
										marginLeft: 'auto',
										textTransform: 'uppercase',
										fontWeight: '800'
									}}
									onClick={(e) => {
										e.stopPropagation()
										setIsDeleteOpen(true)
									}}>
									Delete playgroup
								</Link>
							)}
						</DialogActions>
						{/* <ErrorSection formik={formik} /> */}
					</form>
				</DialogContent>
				<DeleteConfirmation
					isShown={isDeleteOpen}
					setIsShown={setIsDeleteOpen}
					onConfirmDelete={onConfirmDelete}
					isDeleteLoading={isDeleteLoading}
					title="Delete playgroup"
					body="Are you sure you want to delete this playgroup? This action cannot be undone."
				/>
			</Dialog>
		</div>
	)
})

const ErrorSection = ({ formik }) => {
	if (formik.isValid) return null

	const errors = Object.entries(formik.errors)

	return (
		<Box width="100%">
			{errors.map(([label, error], i) => {
				return (
					<Typography key={'errors-' + i} color="error">
						{label}: {error}
					</Typography>
				)
			})}
		</Box>
	)
}
